export class Recept {
  public constructor() {
    this.paidPrice=0;
  }
  public id?:string;
  public drugStoreName?:string;
  public drugStoreNumber?:string;
  public drugStoreAddress?:string;
  public factorNumber?:string;
  public factorDate?:string;
  public prescriptionDate?: string;
  public patientNationalCode?: string;
  public patientFullName?: string;
  public doctorFullName?: string;
  public doctorId?: string;
  public barcode?:string;
  public insuranceAmount?:number;
  public totalAmount?:number;
  public patientAmount?:number;
  public technicalRight?:number;
  public insuranceTechnicalRight?:number;
  public nonInsuredPrice?:number;
  public paidPrice:number;
  public drugTariffPrice?:number;
  public insuranceId?:string;
  public insuranceName?:string;
  public trackingCode?:string;
  public drugList:ReceptDrugList[]=[];
}

export class ReceptDrugList {
  public constructor(
    drugBranName: string,
    count: number,
    sellPrice: number,
    totalPrice: number,
    stockName: string,
    insurancePrice?: number,
    shareCurrencyPrice?: number,
  ) {
    this.drugBranName = drugBranName;
    this.count = count;
    this.sellPrice = sellPrice;
    this.totalPrice = totalPrice;
    this.stockName = stockName;
    if (insurancePrice==null) {
      this.insurancePrice=0;
    }else{
      this.insurancePrice=insurancePrice;
    }
    if (shareCurrencyPrice==null) {
      this.shareCurrencyPrice=0;
    }else{
      this.shareCurrencyPrice=shareCurrencyPrice;
    }
    this.paidPrice=totalPrice-this.insurancePrice-this.shareCurrencyPrice
  }

  public drugBranName: string;
  public count: number;
  public sellPrice: number;
  public insurancePrice: number;
  public shareCurrencyPrice: number;
  public paidPrice: number;
  public totalPrice: number;
  public stockName: string;
  public doctorOrder?:string;
  public description?:string;
}
